import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoBanner, { EcoBannerProps } from '../eco-banner-card/index';
import styles from './index.module.scss';

interface BannerProps {
    pageType: 'ultra' | 'max';
}

const Banner: React.FC<BannerProps> = ({ pageType }: BannerProps = { pageType: 'max' }) => {
    const { locale } = getLocal();
    const { t } = useLang('Banner');

    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);

    const imgMap: any = {
        max: {
            eu: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761544361979-kw8e06-compressed-kv.webp',
                pad: 'https://websiteoss.ecoflow.com/figma-uploads/1761114506147-mhargo-compressed-KV%20pad/mob.webp',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761114506147-mhargo-compressed-KV%20pad/mob.webp',
            },
            uk: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1765273659157/kv.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1765273727555/kv-mob.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1765273727555/kv-mob.jpg',
            },
            us: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760320735520/2%E5%BA%A6%E7%94%B5-pc.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1760410505469/2%E5%BA%A6%E7%94%B5-h5%20(1).jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1760410505469/2%E5%BA%A6%E7%94%B5-h5%20(1).jpg',
            },
            de: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1772420985497/d3mp_kv_de.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1772420985321/d3mp_kv_de_m.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1772420985321/d3mp_kv_de_m.jpg',
            },
        },
        ultra: {
            us: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760320735069/3%E5%BA%A6%E7%94%B5-pc.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1760320734834/3%E5%BA%A6%E7%94%B5-h5.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1760320734834/3%E5%BA%A6%E7%94%B5-h5.jpg',
            },
        },
    };

    let imgResMap = imgMap[pageType as keyof typeof imgMap][isEU ? 'eu' : 'us'];
    if (['uk', 'de'].includes(locale) && pageType === 'max') {
        imgResMap = imgMap[pageType as keyof typeof imgMap][locale];
    }

    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: imgResMap.pc,
        pad: imgResMap.pad,
        h5: imgResMap.h5,
        label: t('label'),
        // labelColor: '#D11504',
        title: t('title'),
        desc: isEU ? t('desc') : null,
        theme: 'white',

        // 按钮
        lType: 'outlined',
        lChildren: t('btn'),
        lHref:
            pageType === 'ultra'
                ? 'https://www.youtube.com/embed/NHfd9db7f34?si=N7jO__fM-qGWXpo2'
                : 'https://www.youtube.com/embed/2aFfdj-mFJs?si=1ZST3-cgdA98mEYy',
        lBtnIsYouToBe: true,
        lDataLayer: {
            __btn_id1: `eco-banner-card-btn-box .__btn_l`,
            __btn_id2: `bannerBtnL`,
            __btn_type: 'common',
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('title'),
            position: 'Product Detail_1',
        },
    };
    return (
        <div className={styles.Banner + ' GtmModuleData-section'} data-section-id="d3m-banner">
            <EcoBanner theme="white" {...dataA} />
            <div className="footer-desc eco-content">{t('footer_desc')}</div>
        </div>
    );
};

export default Banner;
